<ng-template #spuTaxPanel>
  <div class="spu-tax-control">
    <app-product-tax-control
      [value]="taxValue()"
      [inheritedValue]="inheritedTaxValue()"
      [taxOptions]="taxOptions()"
      [disabled]="viewMode || isSaving()"
      [idPrefix]="'spu-tax'"
      (valueChange)="onTaxValueChange($event)"
    ></app-product-tax-control>
  </div>
</ng-template>

<app-add-form
  data-testid="spu-form"
  [title]="updatedFormConfig().title"
  [formFields]="updatedFormConfig().formFields"
  [tableSections]="updatedTableSections()"
  [headerActions]="updatedFormConfig().headerActions"
  [editMode]="editMode"
  [viewMode]="viewMode"
  [initialData]="combinedInitialData()"
  [configurationAppendTemplate]="spuTaxPanel"
  [configurationAppendSectionKey]="'goods.spu.form.sections.product_information'"
  [showSpuFaq]="showFaq"
  [spuFaqItems]="faqItems()"
  (spuFaqItemsChange)="onFaqItemsChange($event)"
  (formAction)="onFormAction($event)"
  (tableAction)="onTableAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
>
  <ng-template #actionsTemplate let-rowData>
    <div class="flex gap-2 justify-center">
      @if (!viewMode) {
        <p-button
          [attr.data-testid]="'spu-form-action-edit-' + rowData.id"
          size="small"
          [label]="'common.actions.edit' | translate"
          severity="info"
          (onClick)="onEditProperty(rowData.id)"
          text
        ></p-button>
        <p-button
          [attr.data-testid]="'spu-form-action-delete-' + rowData.id"
          size="small"
          [label]="'common.actions.delete' | translate"
          severity="danger"
          (onClick)="onDeleteProperty(rowData.id)"
          text
        ></p-button>
      } @else {
        <p-button
          [attr.data-testid]="'spu-form-action-view-' + rowData.id"
          size="small"
          [label]="'common.actions.view' | translate"
          severity="info"
          (onClick)="onViewProperty(rowData.id)"
          text
        ></p-button>
      }
    </div>
  </ng-template>

  <!-- Custom template for Property Asset column -->
  <!-- <ng-template #customTemplate let-rowData let-column="column">
    @if (rowData && rowData.length > 0) {
    <div class="flex flex-col gap-1">
      @for (asset of rowData; track asset.asset) {
      <div class="flex items-center gap-2">
        @if (asset.image) {
        <img
          [src]="asset.image"
          [alt]="asset.originalName"
          class="w-6 h-6 object-cover rounded"
          (error)="onImageError($event)"
        />
        }
        <span
          class="text-xs text-gray-600 truncate"
          [title]="asset.originalName"
        >
          {{ asset.originalName }}
        </span>
      </div>
      }
    </div>
    } @else {
    <span class="text-gray-400 text-sm">-</span>
    }
  </ng-template> -->
</app-add-form>

<!-- RBA-2278: Image alt text (SEO) section - edit mode only -->
@if (editMode && imageAltDisplayItems().length > 0) {
  <div class="image-alt-section" data-testid="spu-form-image-alt-section">
    <h3 class="image-alt-section-title">
      {{ 'goods.spu.form.image_alt.section_title' | translate }}
    </h3>
    <div class="image-alt-list">
      @for (image of imageAltDisplayItems(); track image.objectName; let i = $index) {
        <div class="image-alt-item" [attr.data-testid]="'spu-form-image-alt-item-' + i">
          <img
            [src]="image.url"
            [alt]="image.editedAltText"
            class="image-alt-thumbnail"
            (error)="onImageError($event)"
          />
          <div class="image-alt-fields">
            <label class="image-alt-label" [attr.for]="'spu-form-image-alt-input-' + i">
              {{
                (image.isMain
                  ? 'goods.spu.form.image_alt.main_image'
                  : 'goods.spu.form.image_alt.detail_image_n'
                ) | translate: { n: image.detailIndex }
              }}
            </label>
            <input
              [id]="'spu-form-image-alt-input-' + i"
              type="text"
              class="image-alt-input"
              [attr.data-testid]="'spu-form-image-alt-input-' + i"
              [value]="image.editedAltText"
              (input)="onAltTextChange(image.objectName, $any($event.target).value)"
            />
            <div class="image-alt-meta">
              @if (image.altSource === 'AUTO') {
                <small class="image-alt-hint">
                  {{ 'goods.spu.form.image_alt.auto_generated' | translate }}
                </small>
              }
              @if (image.altSource === 'MANUAL') {
                <button
                  type="button"
                  class="image-alt-reset-btn"
                  [attr.data-testid]="'spu-form-image-alt-reset-' + i"
                  (click)="onResetAltTextToDefault(image.objectName)"
                >
                  {{ 'goods.spu.form.image_alt.reset_to_default' | translate }}
                </button>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

<!-- Add Property Dialog -->
<app-add-property-dialog
  data-testid="spu-form-add-property-dialog"
  [(visible)]="showAddPropertyDialog"
  (confirm)="onPropertyDialogConfirm($event)"
  [initialData]="editingProperty()"
  [hideGenerateSku]="config.spuType === 'package'"
  [detailImages]="detailImagesData"
  (visibleChange)="onPropertyDialogVisibilityChange($event)"
></app-add-property-dialog>

<!-- View Property Dialog -->
<app-add-property-dialog
  data-testid="spu-form-view-property-dialog"
  [(visible)]="showViewPropertyDialog"
  [initialData]="viewingProperty()"
  [viewMode]="true"
  [hideGenerateSku]="config.spuType === 'package'"
  [detailImages]="detailImagesData"
></app-add-property-dialog>

<!-- Toast Messages -->
<p-toast data-testid="spu-form-toast"></p-toast>

<!-- Custom Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'spu-form-confirmation-dialog'"
  [(visible)]="showConfirmationDialog"
  [message]="confirmationMessage()"
  [buttons]="confirmationButtons()"
  (emitOnClick)="onConfirmationDialogAction($event)"
></app-confirmation-dialog>
